const decoration = {
  namespaced: true,
  state: () => ({}),

  getters: {
    initNew3DDecoration:
      (_state, _getters, rootState, rootGetters) =>
      ({
        layout,
        teamName,
        logo,
        fillColor,
        outlineColor1,
        outlineColor2,
        colorsPalette,
      }) => {
        if (!["sublimation", "stock"].includes(colorsPalette))
          throw new Error("colorType must be sublimation or stock");
        console.log("initNew3DDecoration  fillColor", fillColor);
        console.log("initNew3DDecoration  layout", layout);
        // loop through the layout and create the decorations
        const decoration = {};

        for (const decorationType in layout) {
          const location = layout[decorationType]; //Ex: Upper Front
          const fillBackupColor = "WHITE";
          const outlineBackupColor = "BLACK";
          let fontAssetId = "";

          //Get the available fonts for the location, only for the next decorations
          if (
            [
              "Team Name",
              "Front Number",
              "Back Number",
              "Player Name",
            ].includes(decorationType) &&
            location
          ) {
            //Set FULL BLOCK as default font
            fontAssetId = "0a0aff58-0b30-4c7c-a378-899f6fe87c98";
          }

          //Set location assetId
          decoration[location] = {};
          decoration[location]["assetId"] =
            "80633614-496f-464b-abf5-cf741ab7edf2";
            
          switch (decorationType) {
            case "Team Name":
              if (location) {
                decoration[location]["configuration"] = {
                  "Content Type": "Custom Text",
                  Text: teamName,
                  "Text Fill": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](fillColor, fillBackupColor, colorsPalette, true),
                  },
                  "Text Outline 1": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](outlineColor1, outlineBackupColor, colorsPalette),
                  },
                  "Text Outline 2": { assetId: outlineColor2 || "" },
                  "Text Height": `${layout["Team Name Size"]}"`,
                  Font: { assetId: fontAssetId },
                };
              }
              break;

            case "Graphic":
              if (location && logo && logo.asset_id) {
                decoration[location]["configuration"] = {
                  "Content Type": "Graphics",
                  Logo: {
                    assetId: logo.asset_id,
                    name: logo.filename,
                    url: logo.url,
                  },
                  "Text Height": `${layout["Graphic Size"]}"`,
                };
              }
              break;
            case "Graphics":
              if (location && logo && logo.asset_id) {
                decoration[location]["configuration"] = {
                  "Content Type": "Graphics",
                  Logo: {
                    assetId: logo.asset_id,
                    name: logo.filename,
                    url: logo.url,
                  },
                  "Text Height": `${layout["Graphic Size"]}"`,
                };
              }
              break;
            case "Uploads":
              if (location && logo && logo.asset_id) {
                decoration[location]["configuration"] = {
                  "Content Type": "Uploads",
                  Logo: {
                    assetId: logo.asset_id,
                    name: logo.filename,
                    url: logo.url,
                  },
                  "Text Height": `${layout["Graphic Size"]}"`,
                };
              }
              break;

            case "Front Number":
              if (location) {
                decoration[location]["configuration"] = {
                  "Content Type": "Player Number",
                  Text: "23",
                  "Text Fill": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](fillColor, fillBackupColor, colorsPalette),
                  },
                  "Text Outline 1": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](outlineColor1, outlineBackupColor, colorsPalette),
                  },
                  "Text Outline 2": { assetId: outlineColor2 || "" },
                  "Text Height": `${layout["Front Number Size"]}"`,
                  Font: { assetId: fontAssetId },
                };
              }
              break;
            case "Back Number":
              if (location) {
                decoration[location]["configuration"] = {
                  "Content Type": "Player Number",
                  Text: "23",
                  "Text Fill": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](fillColor, fillBackupColor, colorsPalette),
                  },
                  "Text Outline 1": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](outlineColor1, outlineBackupColor, colorsPalette),
                  },
                  "Text Outline 2": { assetId: outlineColor2 || "" },
                  "Text Height": `${layout["Back Number Size"]}"`,
                  Font: { assetId: fontAssetId },
                };
              }
              break;

            case "Player Name":
              if (location) {
                decoration[location]["configuration"] = {
                  "Content Type": "Player Name",
                  Text: "Player Name",
                  "Text Fill": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](fillColor, fillBackupColor, colorsPalette),
                  },
                  "Text Outline 1": {
                    assetId: rootGetters[
                      "threekit/getThreekitColorAssetIdByGameplanId"
                    ](outlineColor1, outlineBackupColor, colorsPalette),
                  },
                  "Text Outline 2": { assetId: outlineColor2 || "" },
                  "Text Height": `${layout["Player Name Size"]}"`,
                  Font: { assetId: fontAssetId },
                };
              }
              break;
          }
        }
        console.log("decoration setup: ", decoration);
        return decoration;
      },
  },
};

export default decoration;
